import { CONV_STORAGE, Video, kinoParticipants, volumeManager } from "../../../libs/roomnew"
import { SPACE_CHANGED } from "./constants"
import { handleSpaceMenuUpdate, volumeHandleLocalParticipantSpaceChange, volumeHandleRemoteParticipantSpaceChange } from "./handlers"

export const addSpacesEventHandlers=()=>{
    window.addEventListener(SPACE_CHANGED,({detail:data})=>{
        console.log(`%c[EVENT]%c - SPACE_CHANGED`,'color:green','color:unset',data)
        onSpaceChanged(data)
    })
}

const onSpaceChanged=(data)=>{
    const participant = kinoParticipants.get(data.pid);
    if(!participant){return}
    const space = data.newSpace ? CONV_STORAGE.getSpace(data.newSpace) : null;
    const oldSpace = data.oldSpace ? CONV_STORAGE.getSpace(data.oldSpace) : null;
    Video.efss.inViewPortConversations(false);
    if(participant.local)
    onLocalParticipantSpaceChanged(space,oldSpace)
    else
    onRemoteParticipantSpaceChanged(participant,space,oldSpace)
    handleSpaceMenuUpdate(space, oldSpace)
}

const onLocalParticipantSpaceChanged=(space,oldSpace=null)=>{
    volumeHandleLocalParticipantSpaceChange(space,oldSpace)
    volumeManager.stateChangedWhileMuted=true;
    // if(Video.lockMasterVolume.isLocked()){
    //     Video.lockMasterVolume.updateIndividualVolumeSlider();
    // }
}

const onRemoteParticipantSpaceChanged=(participant,space,oldSpace=null)=>{
    volumeHandleRemoteParticipantSpaceChange(participant,space,oldSpace)
    // handleSpaceMenuUpdate(space, oldSpace)
}
